
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12 border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-20 h-20 bg-gradient-to-r from-lumaz-primary to-lumaz-secondary rounded-full flex items-center justify-center text-white font-bold text-2xl hover:scale-110 transition-transform duration-300 cursor-pointer shadow-lg">
                DB
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                  Dion Bamme
                </h3>
                <p className="text-gray-300">Marketing Management Student</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed max-w-md">
              Leidenschaftlicher Marketing Student mit dem Fokus auf kreative Kampagnen 
              und innovative digitale Lösungen für moderne Unternehmen.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover;text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                  Über mich
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Kontakt</h4>
            <div className="space-y-2">
              <p className="text-gray-300 flex items-center">
                <i className="ri-mail-line mr-2 text-lumaz-secondary"></i>
                dion.bamme@gmail.com
              </p>
              <p className="text-gray-300 flex items-center">
                <i className="ri-phone-line mr-2 text-lumaz-secondary"></i>
                +49 176 45725863
              </p>
              <p className="text-gray-300 flex items-center">
                <i className="ri-map-pin-line mr-2 text-lumaz-secondary"></i>
                Wernigerode, Deutschland
              </p>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-4 mb-4 md:mb-0">
              {[
                { icon: 'ri-linkedin-fill', url: '#', label: 'LinkedIn' },
                { icon: 'ri-instagram-line', url: 'https://www.instagram.com/dionsaurier/', label: 'Instagram' },
                { icon: 'ri-twitter-fill', url: '#', label: 'Twitter' },
                { icon: 'ri-github-fill', url: '#', label: 'GitHub' }
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target={social.url.startsWith('http') ? '_blank' : '_self'}
                  rel={social.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="w-10 h-10 bg-gray-700 hover:bg-lumaz-secondary rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer hover:scale-110"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-gray-300 hover:text-white text-lg`}></i>
                </a>
              ))}
            </div>

            {/* Copyright & Legal Links - Improved visibility */}
            <div className="text-center md:text-right">
              <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm mb-3">
                <Link 
                  to="/privacy" 
                  className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer font-medium px-3 py-1 rounded hover:bg-gray-700"
                >
                  Datenschutz
                </Link>
                <Link 
                  to="/legal" 
                  className="text-gray-300 hover:text-lumaz-secondary transition-colors duration-300 cursor-pointer font-medium px-3 py-1 rounded hover:bg-gray-700"
                >
                  Impressum
                </Link>
              </div>
              <p className="text-gray-400 text-sm">
                © 2025 Dion Bamme. Alle Rechte vorbehalten.
              </p>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}
